// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"8323c7e9","453":"b725784f"}[chunkId] + ".chunk.js";
};